import { Flex } from "Element/Flex";
import styled, { keyframes } from "styled-components";
import runningBg from "assets/images/runningdoge.png";

export const AboutWrapper = styled.div`
  padding-bottom: 40px;
`;
export const ScholarContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.neutral20};
  padding: 180px 72px 116px;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    padding: 72px 24px 24px;
  `}
`;

export const AboutContainer = styled.div`
  padding: 40px 72px 120px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    padding: 40px 24px 80px;
  `}
  h1 {
    margin-bottom: 48px;
  }
  p {
    :first-child {
      margin-bottom: 16px;
    }
  }
`;

export const Description = styled.p`
  font-size: 18px;
`;

export const DogeImgContainer = styled.div`
  width: 180px;
  height: 180px;
  border-radius: ${({ theme }) => theme.borderRadius.small};
  background-color: ${({ theme }) => theme.colors.secondary40};
`;

export const CarouselWrapper = styled(Flex)`
  position: relative;
  margin-top: 40px;
`;

export const ImgAni = keyframes`
	0%{background-position: 0 0;}
  100%{background-position: -100vw 0;}
`;

export const RunningImg = styled.div`
  background: url(${runningBg});
  background-repeat: repeat-x;
  height: 180px;
  width: 100%;
  /* position: absolute; */
  background-size: cover;
  background-position: center;
  animation: ${ImgAni} 15s linear infinite;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    height: 80px;
  `}
`;

export const ScholarWrapper = styled(Flex)`
  margin-bottom: 40px;
  .scholar-text {
    margin-right: 120px;
  }
  h1 {
    margin-bottom: 24px;
  }
  p {
    :first-child {
      margin-bottom: 16px;
    }
  }
  ${({ theme }) => theme.mediaWidth.upToMedium`
    flex-direction: column;
    .scholar-text{
      margin-bottom: 32px;
      margin-right: 0;
    }
  `}
`;

export const DogeBoss = styled.img`
  ${({ theme }) => theme.mediaWidth.upToMedium`
    margin: 0 auto;
  `}
  ${({ theme }) => theme.mediaWidth.upToXxs`
    width: 100%;
  `}
`;

export const WavesWrapper = styled(Flex)`
  h1 {
    :first-child {
      margin-bottom: 24px;
    }
  }
  .desc-wrapper {
    margin-bottom: 24px;
    p {
      :first-child {
        margin-bottom: 16px;
      }
    }
  }
`;

export const WavesImg = styled.img`
  width: 200px;

  ${({ theme }) => theme.mediaWidth.upToSmall`
    width: 148px;
  `};
`;

export const WavesName = styled.h1`
  margin-top: 12px;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    font-size: 28px;
    text-align: center;
  `}
`;

export const WavesContainer = styled(Flex)`
  ${({ theme }) => theme.mediaWidth.upToSmall`
    justify-content: center;
  `};
`;
export const TheWave = styled(Flex)`
  margin-top: 24px;
  margin-right: 48px;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    margin-bottom: 24px;
    margin-right: 24px;
    margin-top: 0px;
  `};
`;
